// extracted by mini-css-extract-plugin
export default {"unclaimedClaimModule":"unclaimedClaimModule__ZmU2M","heading":"heading__OWYyO"};